import { Flex, Icon, Image, Text, useDisclosure } from '@chakra-ui/react';
import { IconChartPie3, IconCoin, IconDragDrop, IconHelp } from '@tabler/icons';
import { ButtonComponent } from 'components/buttons/ButtonComponent';
import Card from 'components/card/Card';
import { RecentActivityLogModal } from 'components/modal/RecentActivityLogModal';
import { useGlobalContext } from 'contexts/GlobalContext';
import { SidebarHelpContext } from 'contexts/SidebarHelpContext';
import { ISidebarHelp } from 'models/sidebarHelp/sidebarHelp.model';
import { useContext, useEffect } from 'react';
import { TbClockShare } from 'react-icons/tb';
import { useHistory } from 'react-router-dom';
import { URL_CT360, URL_FALE_CONOSCO } from 'utils/consts/global';

export default function Introdução() {
	const { setters } = useContext(SidebarHelpContext);

	const {
		isOpen: isOpenRecentActivityLogModal,
		onOpen: onOpenRecentActivityLogModal,
		onClose: onCloseRecentActivityLogModal,
	} = useDisclosure();

	const { setDataSidebar } = setters;

	const helpMetas: ISidebarHelp = {
		title: 'Seja Bem-Vindo a Easy360',
		firstParagraph:
			'Nesta tela é possível seguir os primeiros passos de configuração inicial da easy360! Para que você desfrute completamente da esy360, é importante subir seu histórico de vendas para em seguida calcular o preço médio dos produtos e rateio de vendas. Estas informações são fundamentais para o bom funcionamento da easy360!',
		firstLink: URL_CT360,
		secondLink: URL_FALE_CONOSCO,
	};

	useEffect(() => {
		setDataSidebar(helpMetas);
	}, []);

	const { pathCompanyName, userAttributes } = useGlobalContext();

	const history = useHistory();

	return (
		<Flex
			pt={{ base: '130px', md: '80px', xl: '70px' }}
			pl='20px'
			flexWrap='wrap'
		>
			<Card
				h={'80vh'}
				style={{
					backgroundImage: `url("assets/images/background/bg-home-granularity.webp")`,
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
				}}
				borderRadius='30px'
			>
				<Image
					w={'350px'}
					position={'absolute'}
					left={0}
					src='assets/images/decoratives/lines-and-dots-left.png'
				/>
				<Image
					w={'350px'}
					position={'absolute'}
					right={0}
					src='assets/images/decoratives/lines-and-dots-right.png'
				/>
				<Flex
					flexDirection={'column'}
					w={'100%'}
					margin={'0 auto'}
					alignItems={'center'}
					my={36}
					position={'absolute'}
				>
					<Text
						fontSize={'40px'}
						py={'10px'}
						mb={4}
						px={'30px'}
						border={'2px solid'}
						color={'easy360.bgWhite'}
					>
						{userAttributes ? userAttributes.name : ''}
					</Text>
					<Text
						fontSize={'40px'}
						mb={16}
						color={'easy360.bgWhite'}
					>
						Seja bem-vindo a Easy360!
					</Text>

					<Text
						fontSize={'20px'}
						color={'easy360.bgWhite'}
					>
						Vamos começar?
					</Text>
				</Flex>
				<Flex
					gap={4}
					position={'absolute'}
					w={'97%'}
					bottom={'-35px'}
				>
					<Card
						bgColor='easy360.bgCard'
						borderRadius='30px'
						justifyContent={'space-between'}
						padding={'20px'}
					>
						<Flex flexDirection={'column'}>
							<Icon
								as={IconCoin}
								boxSize={12}
								color={'easyRED.300'}
							/>
							<Text
								color={'easyBLUE.300'}
								fontSize={'20px'}
								fontWeight={'600'}
							>
								Suba suas vendas
							</Text>
							<Text
								color={'easyRED.300'}
								fontWeight={'600'}
							>
								Vendas
							</Text>
							<Text color={'easyBLUE.300'}>
								Importe o seu histórico de vendas.
							</Text>
						</Flex>

						<ButtonComponent
							marginTop={'4px'}
							fontSize={'13px'}
							type={'secondary'}
							background={'easy360.gradients.red'}
							color={'easy360.bgWhite'}
							borderRadius={'15px'}
							border={'none'}
							_hover={{
								background: 'easyRED.450',
							}}
							title={'Clique aqui'}
							onClick={() =>
								history.push(
									`/${pathCompanyName}/cadastros/comercial/venda`
								)
							}
						/>
					</Card>
					<Card
						bgColor='easy360.bgCard'
						borderRadius='30px'
						justifyContent={'space-between'}
						padding={'20px'}
					>
						<Flex flexDirection={'column'}>
							<Icon
								as={IconDragDrop}
								boxSize={12}
								color={'easyRED.300'}
							/>
							<Text
								color={'easyBLUE.300'}
								fontSize={'20px'}
								fontWeight={'600'}
							>
								Calcule seu preço médio
							</Text>
							<Text
								color={'easyRED.300'}
								fontWeight={'600'}
							>
								Ticket
							</Text>
							<Text color={'easyBLUE.300'}>
								Calcule o preço médio de vendas de todos seus
								produtos.
							</Text>
						</Flex>

						<ButtonComponent
							marginTop={'4px'}
							fontSize={'13px'}
							type={'secondary'}
							background={'easy360.gradients.red'}
							color={'easy360.bgWhite'}
							borderRadius={'15px'}
							border={'none'}
							_hover={{
								background: 'easyRED.450',
							}}
							title={'Clique aqui'}
							onClick={() =>
								history.push(
									`/${pathCompanyName}/demanda/ticketMedio`
								)
							}
						/>
					</Card>
					<Card
						bgColor='easy360.bgCard'
						borderRadius='30px'
						justifyContent={'space-between'}
						padding={'20px'}
					>
						<Flex flexDirection={'column'}>
							<Icon
								as={IconChartPie3}
								boxSize={12}
								color={'easyRED.300'}
							/>
							<Text
								color={'easyBLUE.300'}
								fontSize={'20px'}
								fontWeight={'600'}
							>
								Realize sua demanda
							</Text>
							<Text
								color={'easyRED.300'}
								fontWeight={'600'}
							>
								Colaboração
							</Text>
							<Text color={'easyBLUE.300'}>
								Planeje a demanda dos próximos meses.
							</Text>
						</Flex>

						<ButtonComponent
							marginTop={'4px'}
							fontSize={'13px'}
							type={'secondary'}
							background={'easy360.gradients.red'}
							color={'easy360.bgWhite'}
							borderRadius={'15px'}
							border={'none'}
							_hover={{
								background: 'easyRED.450',
							}}
							title={'Clique aqui'}
							onClick={() =>
								history.push(
									`/${pathCompanyName}/demanda/colaboracao`
								)
							}
						/>
					</Card>
					<Card
						bgColor='easy360.bgCard'
						borderRadius='30px'
						justifyContent={'space-between'}
						padding={'20px'}
					>
						<Flex flexDirection={'column'}>
							<Icon
								as={TbClockShare}
								boxSize={12}
								color={'easyRED.300'}
							/>
							<Text
								color={'easyBLUE.300'}
								fontSize={'20px'}
								fontWeight={'600'}
							>
								Atividades Recentes
							</Text>
							<Text
								color={'easyRED.300'}
								fontWeight={'600'}
							>
								Atividades
							</Text>
							<Text color={'easyBLUE.300'}>
								Analise as atividades recentes dos usuários.
							</Text>
						</Flex>

						<ButtonComponent
							marginTop={'4px'}
							fontSize={'13px'}
							type={'secondary'}
							background={'easy360.gradients.red'}
							color={'easy360.bgWhite'}
							borderRadius={'15px'}
							border={'none'}
							_hover={{
								background: 'easyRED.450',
							}}
							title={'Clique aqui'}
							onClick={onOpenRecentActivityLogModal}
						/>
					</Card>
					<Card
						bgColor='easy360.bgCard'
						borderRadius='30px'
						justifyContent={'space-between'}
						padding={'20px'}
					>
						<Flex flexDirection={'column'}>
							<Icon
								as={IconHelp}
								boxSize={12}
								color={'easyRED.300'}
							/>
							<Text
								color={'easyBLUE.300'}
								fontSize={'20px'}
								fontWeight={'600'}
							>
								Dúvidas
							</Text>
							<Text
								color={'easyRED.300'}
								fontWeight={'600'}
							>
								Fale conosco
							</Text>
							<Text color={'easyBLUE.300'}>
								Será sempre um prazer te ajudar!
							</Text>
						</Flex>

						<ButtonComponent
							marginTop={'4px'}
							fontSize={'13px'}
							type={'secondary'}
							background={'easy360.gradients.red'}
							color={'easy360.bgWhite'}
							borderRadius={'15px'}
							border={'none'}
							_hover={{
								background: 'easyRED.450',
							}}
							title={'Clique aqui'}
							onClick={() =>
								window.open(
									'https://www.easy360.ind.br/contato',
									'_blank'
								)
							}
						/>
					</Card>
				</Flex>
			</Card>
			<RecentActivityLogModal
				isOpen={isOpenRecentActivityLogModal}
				onClose={onCloseRecentActivityLogModal}
			/>
		</Flex>
	);
}
